module.exports = __webpack_public_path__ + "img/landscape-electronics.ea2eb240.svg";